import { Fragment } from "react";
import { cn } from "~utils";
import type { HeroSectionProps } from "../types";

function HeroSectionHeading({ blok }: HeroSectionProps) {
  const headingParts = blok.title
    .split(/\r?\n|\\n/)
    .map(p => p.trim())
    .filter(Boolean);

  return (
    <h1
      className={cn(
        "flex w-full flex-col text-pretty text-content-heading",
        blok.centered ? "t-strong-5xl" : "t-strong-6xl whitespace-pre-line",
        blok.textVariant === "white" && "text-others-white",
        blok.textVariant === "black" && "text-others-black",
        blok.titleFontFamily,
      )}
    >
      {headingParts.map((part, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <Index can be used in this case>
        <Fragment key={index}>
          {blok.centered ? (
            <Fragment>
              {part}
              {index < headingParts.length - 1 && <br />}
            </Fragment>
          ) : (
            <span
              className={cn(
                index === 1 &&
                  "w-full max-w-[var(--second-part-max-w)] sm:ml-auto",
              )}
            >
              {part}
            </span>
          )}
        </Fragment>
      ))}
    </h1>
  );
}

export { HeroSectionHeading };
